var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.908 18.836a.969.969 0 00-.612-.697l-3.658-.942s-3.59-4.17-3.743-4.378a2.086 2.086 0 00-.643-.59 1.983 1.983 0 00-.945-.23 4.577 4.577 0 00-3.586 2.69c-1.121 2.098-.912 4.396.469 5.135.208.111 1.91.672 2.9 1.02a5.53 5.53 0 002.479-2.39l.918.397a6.34 6.34 0 01-2.167 2.427l.845.298a5.52 5.52 0 002.295-2.29l.917.397A6.324 6.324 0 0116.367 22l.825.29a5.45 5.45 0 002.118-2.192l.918.397a6.247 6.247 0 01-1.862 2.208l1.657.583c.378.133 1.315.275 2.428-1.817a3.384 3.384 0 00.457-2.632zm-12.305-3.674A3.612 3.612 0 0113.307 13a.979.979 0 01.473.111c.766.41.978 2.063.059 3.781a3.612 3.612 0 01-2.704 2.162.978.978 0 01-.474-.112c-.765-.409-.977-2.062-.058-3.78zm10.334-4.992a2.244 2.244 0 00-1.753.175v-.002a1.835 1.835 0 01-1.418.169l-.017-.005-3.806-1.19-4.31-1.298a.5.5 0 10-.276.961l.004.001 4.348 1.163 3.882 1.02.046.014a1.833 1.833 0 011.12.885l.004-.004a2.268 2.268 0 001.36.998 1.864 1.864 0 002.368-.89c.219-.772-.489-1.696-1.552-1.996z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--plastic-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'PlasticCircleIcon';
export default Icon;